import { gql } from '@apollo/client';

export const TERMINE_TERMIN_CREATE = gql`
  mutation CreateTermin(
    $managerId: String!
    $termin: termine_terminCreateInput!
  ) {
    termine_terminCreate(managerId: $managerId, termin: $termin) {
      error {
        message
      }
      result {
        id
        titel
        datum
        beginn
        ende
        standortId
        terminKalenderId
        markierung
        wiederholung
        wiederholungBis
        termineDetails {
          beschreibung
          specials
        }
        image {
          name
          url
          thumbnailUrl
          contentType
        }
      }
    }
  }
`;
